/** Срок жизни пользовательских cookie — 30 дней, как COOKIES_MAX_AGE в вебе. */
export const COOKIES_MAX_AGE = 30 * 24 * 3600

/** Префикс запасного хранилища — чтобы не путать эти ключи с обычными. */
const FALLBACK_PREFIX = 'cookie:'

/**
 * В Telegram Web мини-апп открыт в чужом iframe, и cookie с `SameSite=Lax`
 * браузер молча выбрасывает — запись «проходит», но не сохраняется.
 * Там нужен `None`, который требует `Secure`, поэтому на локальном http
 * остаёмся с `Lax`. `Partitioned` — чтобы пережить блокировку сторонних cookie.
 */
function cookieFlags(): string {
  const isEmbedded = window.top !== window.self
  const isSecure = location.protocol === 'https:'
  return isEmbedded && isSecure ? 'SameSite=None; Secure; Partitioned' : 'SameSite=Lax'
}

/* Приватный режим умеет запрещать и localStorage — молчаливый отказ лучше падения */
function readFallback(name: string): string {
  try {
    return localStorage.getItem(FALLBACK_PREFIX + name) ?? ''
  } catch {
    return ''
  }
}

function writeFallback(name: string, value: string): void {
  try {
    localStorage.setItem(FALLBACK_PREFIX + name, value)
  } catch {
    /* некуда сохранить — состояние проживёт до перезагрузки */
  }
}

function clearFallback(name: string): void {
  try {
    localStorage.removeItem(FALLBACK_PREFIX + name)
  } catch {
    /* нечего чистить */
  }
}

export function getCookie(name: string): string {
  const prefix = `${encodeURIComponent(name)}=`
  const found = document.cookie.split('; ').find((row) => row.startsWith(prefix))

  return found ? decodeURIComponent(found.slice(prefix.length)) : readFallback(name)
}

/**
 * Пустое значение удаляет cookie. Записав, сразу проверяем, что она прижилась:
 * если браузер её выбросил (сторонний контекст, запрет хранилища), состояние
 * переезжает в localStorage — иначе клиент вылетал бы на регистрацию заново.
 */
export function setCookie(name: string, value: string, maxAge = COOKIES_MAX_AGE): void {
  const encoded = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
  document.cookie = `${encoded}; path=/; max-age=${value ? maxAge : 0}; ${cookieFlags()}`

  if (value && !document.cookie.includes(encoded)) writeFallback(name, value)
  else clearFallback(name)
}
